<div class="content grid-auto-1 md3-surface">
  <div class="content " style="width: 360px;">
    <div class="layout-list-quickfilter  md3-card-on-surface">
      <exg-search-bar class="span-layout" [placeholder]="getGlobal('SearchBoxText')" (Search)="onSearch($event)">
        <ng-template #rightTemplate>
          <i class="search-action fal fa-sync"
             [tooltip]="getGlobal('Refresh')"
             (click)="getInitilalData()"
             flow="down">
          </i>
          <i class="search-action fal fa-plus"
             *ngIf="excSecurity.isFeatured('LIBCREATE')"
             [tooltip]="getRessource('NewLibrary')"
             flow="left" (click)="addNewLibrary()" ></i>
        </ng-template>
      </exg-search-bar>
      <div class="content">
      <exg-data-table #Libraries
                      containerClass="grid cols-1"
                       [allowMultiSelection]="false"
                      [allowSingleSelection]="true"
                      [rowSource]="libraryList"
                      [displayState]= "libTableState"
                      selectKey="libID"
                      (RowChange)="onRowSelect($event)">
        <ng-template #headerTemplate>
          <div>{{getRessource('NameHeader')}}</div>
        </ng-template>
        <ng-template #rowTemplate let-row>
          <div ><i class="fal fa-book library-icon" style="padding-right: 6px"></i>{{row.libDescription}}</div>
          <ng-template #noAuditor></ng-template>
        </ng-template>
      </exg-data-table>
      </div>
      <div class="app-drawer">
        <button class="fa-icon-plus-counter" (click)="showInfo()" [tooltip]="getRessource('EditLibrary')"
                [disabled]="!selectedLibrary || (selectedLibrary.libComment && selectedLibrary.libComment.length === 0)" flow="left">
          <i class="fal fa-info-square" ></i>
        </button>
        <button class="fa-icon-plus-counter" (click)="editLibrary()"
                *ngIf="excSecurity.isFeatured('LIBEDIT')"
                [tooltip]="getRessource('EditLibrary')" flow="left" [disabled]="!selectedLibrary">
          <i class="fal fa-edit"></i>
        </button>
        <button class="fa-icon-plus-counter" (click)="deleteLib()"
                *ngIf="excSecurity.isFeatured('LIBDELETE')"
                [tooltip]="getRessource('Delete')" flow="left" [disabled]="!selectedLibrary">
          <i class="fal fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="content " >
    <div class="layout-auto-1-auto md3-card-on-surface">
      <exg-search-bar [placeholder]="getGlobal('SearchBoxText')" (Search)="onContentSearch($event)">
          <ng-template #rightTemplate>
            <i class="search-action fal fa-sync" (click)="refreshContent()"
               [tooltip]="getGlobal('Refresh')" flow="down"></i>
            <i class="search-action fal fa-level-up" (click)="levelUp()"  [tooltip]="getRessource('Up')"
               flow="left"  [ngClass]="breadcrumbs.length> 0 ? '' : 'library-disabled'">
            </i>
            <ng-container *ngIf="excSecurity.isFeatured('LIBEDIT')">
              <i class="search-action fal fa-folder-plus" [tooltip]="getRessource('NewDirectory')"
                 (click)="addNewFolder()" flow="left"></i>
              <i class="search-action fal fa-pen" *ngIf="libraryContent.length !== 0 && selectedContent?.libType==='Folder'"
                 [tooltip]="getRessource('EditDirectory')" (click)="editFolder()" flow="left"></i>
              <i (filesSelect)="uploadDocuments($event)" [tooltip]="getRessource('FileUpload')" [dnd]="true"
                 class="search-action fal fa-upload" flow="left" [multiple]="true" appExgDirectUploadV2>   </i>
              <i class="search-action fal fa-pen" *ngIf="selectedContent && selectedContent.libType === 'File'" flow="left" [tooltip]="getRessource('EditFileInfo')"
                 [ngClass]="libraryContent.length !== 0? '' :  'library-disabled'" (click)="editFileInfo()"></i>
              <i class="search-action fal fa-trash" *ngIf="selectedContent" flow="left" [tooltip]="getRessource('Delete')"
                 [ngClass]="libraryContent.length !== 0? '' :  'library-disabled'" (click)="deleteLibContent()"></i>
            </ng-container>
          </ng-template>
        </exg-search-bar>
      <div class="content">
      <exg-data-table #SubContect
                      containerClass="grid cols-3"
                      [allowMultiSelection]="false"
                      [allowSingleSelection]="true"
                      [rowSource]="libraryContent"
                      (RowDblClick)="onContentClick($event)"
                      [displayState]= "tableState"
                      (RowChange)="onContentRowSelect($event)"
                      selectKey="libID">
        <ng-template #headerTemplate>
          <div>{{getRessource('Content')}}</div>
          <div class="span-2">{{getRessource('Comment')}}</div>
        </ng-template>
        <ng-template #rowTemplate let-row>
          <div>
            <i style="padding-right: 0.5rem; text-overflow: initial;" class="fal library-icon"
               [ngClass]="getFileFolderClass(row)"></i>{{row.libDescription}}
          </div>
          <div class="span-2"><p>{{row.libComment}}</p></div>
          <ng-template #noAuditor></ng-template>
        </ng-template>
      </exg-data-table>
      </div>
      <div class="breadcrumbs-container" >
        <ng-container *ngIf="breadcrumbs!== undefined">
          <label class="breadcrumbs-item" *ngIf="selectedLibrary" (click)="onRowSelect(selectedLibIndex)">
            {{selectedLibrary.libDescription}}</label>
          <div *ngFor="let item of breadcrumbs; index as i;" [attr.data-index]="i" class="d-inline-block">
            <i class="fal fa-chevron-right"></i><label class="breadcrumbs-item" (click)="goBreadcrumb(i+1)">
            {{item?.libDescription}}</label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

